export default function PaymentBadge({ method, status, testid }) {
  const paid = status === "paid";
  const cod = (method || "").toLowerCase() === "cod";
  const c = paid ? "#16A34A" : cod ? "#64748B" : "#F59E0B";
  const label = paid ? "Payment Paid" : cod ? "Cash on Delivery" : "Payment Pending";
  return (
    <span
      data-testid={testid || "payment-badge"}
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[11px] font-bold"
      style={{ color: c, backgroundColor: c + "1A" }}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {label}
    </span>
  );
}
